import type { NextPage, GetStaticProps } from 'next';

import PageService from 'services/PageService/PageService';
import PageLayout from 'blocks/Layouts/page-layout';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import StaticPageContent, {
  type StaticPageContentProps,
} from 'data/staticPageContent';
import data from 'data/privacypolicy.json';

import type { PrivacyPolicyType } from 'types/types';
import type { IGenericPage } from 'types/interfaces';

import privacyPolicyImage from 'assets/privacy-policy/header-image.webp';
import AccordionList from 'components/accordion-list';
import PrivacyPolicyItem from 'blocks/privacy-policy-item';

interface IPrivacyPolicy extends IGenericPage {
  pageContent: StaticPageContentProps;
  privacyPolicies: PrivacyPolicyType[];
}

const PrivacyPolicy: NextPage<IPrivacyPolicy> = ({
  globalLayoutProps,
  privacyPolicies,
  pageContent,
}) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <PageLayout {...pageContent} image={privacyPolicyImage}>
        <div className="privacy-policy-page">
          <AccordionList<typeof privacyPolicies[number]>
          items={privacyPolicies}
          getId={item => item.title}
          getTitle={item => item.title}
          getContent={item => [item]}
          renderContent={item => (
            <PrivacyPolicyItem privacyPolicies={item.list} />
          )}
        />
        </div>
      </PageLayout>
    </GlobalLayout>
  );
};

export default PrivacyPolicy;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.PRIVACY_POLICY,
  });
  const pageContent = StaticPageContent[navigationPaths.PRIVACY_POLICY];

  return {
    props: {
      ...genericPageProps,
      pageContent,
      privacyPolicies: data,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
